import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { authService } from '../services/authService'

const VerifyEmail = () => {
  const navigate = useNavigate()
  const { login } = useAuth()
  const started = useRef(false)
  const [state, setState] = useState({ status: 'loading', message: 'Ověřujeme váš e-mail…' })

  useEffect(() => {
    if (started.current) return
    started.current = true
    const token = new URLSearchParams(window.location.search).get('token')
    if (!token) {
      setState({ status: 'error', message: 'Ověřovací odkaz není platný.' })
      return
    }

    let redirectTimer
    authService.verifyEmail(token)
      .then((data) => {
        login(data.user)
        setState({ status: 'success', message: 'E-mail je ověřený. Otevíráme aplikaci…' })
        redirectTimer = window.setTimeout(() => navigate('/dashboard', { replace: true }), 900)
      })
      .catch(() => setState({ status: 'error', message: 'Odkaz je neplatný nebo už vypršel.' }))

    return () => {
      if (redirectTimer) window.clearTimeout(redirectTimer)
    }
  }, [login, navigate])

  return (
    <main className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <section className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-xl">
        <div className={`mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full text-2xl ${state.status === 'error' ? 'bg-red-100 text-red-700' : 'bg-lime-200 text-gray-900'}`}>
          {state.status === 'error' ? '!' : state.status === 'success' ? '✓' : '…'}
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Ověření e-mailu</h1>
        <p className="mt-3 text-gray-600">{state.message}</p>
        {state.status === 'error' && (
          <button type="button" onClick={() => navigate('/', { replace: true })} className="mt-6 rounded-full bg-gray-900 px-6 py-3 font-medium text-white hover:bg-gray-800">
            Přejít na přihlášení
          </button>
        )}
      </section>
    </main>
  )
}

export default VerifyEmail
